import { render, staticRenderFns } from "./BuildPhaseUnitGroups.vue?vue&type=template&id=0f6aa3cb&scoped=true"
import script from "./BuildPhaseUnitGroups.vue?vue&type=script&lang=ts"
export * from "./BuildPhaseUnitGroups.vue?vue&type=script&lang=ts"
import style0 from "./BuildPhaseUnitGroups.vue?vue&type=style&index=0&id=0f6aa3cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6aa3cb",
  null
  
)

export default component.exports